import React, { Component, PropTypes } from 'react';
import Drawer from 'components/Drawer';
import { StoreOverviewActions } from 'actions';
import StoreLayoutEditor from 'components/Store/Editor/StoreLayoutEditor';
import StoreModuleEditor from 'components/Store/Editor/StoreModuleEditor';

const css = oxygenCss({
  layoutEditor: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 390
  },
  moduleEditor: {
    position: 'absolute',
    left: 390,
    bottom: 0,
    width: 390,
    top: 0
  },
  root: {
    overflow: 'hidden'
  }
});

class StoreLayoutOverview extends Component {
  static propTypes = {
    layout: PropTypes.object,
    canUndo: PropTypes.bool,
    mode: PropTypes.string,
    categories: PropTypes.array,
    selectedModule: PropTypes.object,
    selectedSection: PropTypes.object
  };

  unselect = () => {
    StoreOverviewActions.unselect();
  };

  render() {
    const {
      mode,
      layout,
      selectedModule,
      selectedSection,
      canUndo,
      categories,
      ...other
    } = this.props;
    return (
      <Drawer
        className={css.root}
        // closeOnEsc={false}
        onRequestClose={this.unselect}
        {...other}
      >
        <div className={css.layoutEditor}>
          <StoreLayoutEditor
            canUndo={canUndo}
            layout={layout}
            selectedModule={selectedModule}
          />
        </div>
        {selectedModule && (
          <div className={css.moduleEditor}>
            <StoreModuleEditor
              selectedModule={selectedModule}
              selectedSection={selectedSection}
              categories={categories}
            />
          </div>
        )}
      </Drawer>
    );
  }
}

export default StoreLayoutOverview;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/StoreLayoutOverview.js